module.exports = __webpack_public_path__ + "img/zichan1.fed1dd20.png";